import { Button, Popup } from '@missionlabs/smartagent-app-components'
import CloseIconWhite from 'images/close-icon-white.svg'
import ChatIcon from 'images/chat-icon-filled.svg'
import { ReactNode, useEffect, useRef } from 'react'
import styles from './PopupRedesigned.module.scss'

interface PopupRedesignedProps {
    children?: ReactNode
    subject?: string
    onClose: () => void
    getHeight: (height: number) => void
}

const PopupRedesigned = ({ children, subject, onClose, getHeight }: PopupRedesignedProps) => {
    const popupChildrenEl = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        if (popupChildrenEl && popupChildrenEl.current) {
            const computedStyle = getComputedStyle(popupChildrenEl.current)

            getHeight(
                popupChildrenEl.current.getBoundingClientRect().height -
                    parseFloat(computedStyle.paddingTop) -
                    parseFloat(computedStyle.paddingBottom),
            )
        }
    }, [])

    return (
        <Popup center noFocusOnOpen className={styles.popupWrapper}>
            <div className={styles.popupContainer}>
                <div className={styles.popupContainerHeader}>
                    <img
                        src={ChatIcon}
                        alt="chat-icon"
                        className={styles.popupContainerHeader_chatIcon}
                    />
                    <p className={styles.popupContainerHeader_text}>
                        {subject}
                    </p>
                    <Button
                        onClick={onClose}
                        className={styles.popupContainerHeader_closeIcon}
                        role="button"
                    >
                        <img src={CloseIconWhite} alt="close-icon-white" />
                    </Button>
                </div>
                <div className={styles.popupInfo} ref={popupChildrenEl}>
                    {children}
                </div>
            </div>
        </Popup>
    )
}

export default PopupRedesigned
